export default __webpack_public_path__ + "static/media/jordan-signature.48d0a093.png";